import { t } from "i18next";
var ErrorsCodes = function (props) {
    var code = props.code;
    var errors = {
        ERR_GO0010: "Request Unsuccessfull",
        ERR_GO0011: "ERR_GO0011",
        //Invalid BU
        ERR_GO0012: "ERR_GO0012",
        //Schema not found
        ERR_GO0013: "ERR_GO0013",
        //Agent not configured in schema
        ERR_GO0014: "ERR_GO0014",
        //Session expired
        ERR_AP0001: "ERR_AP0001",
        //Invalid expected date
        ERR_AP0002: "ERR_AP0002",
        //Invalid BranchId
        ERR_AP0003: "ERR_AP0003",
        //Dealer is not available
        ERR_AP0004: "ERR_AP0004",
        //Time slot data not available
        ERR_AP0005: "ERR_AP0005",
        //Invalid expected slot
        ERR_AP0006: "ERR_AP0006",
        //Invalid Booking Details
        ERR_AP0007: "ERR_AP0007",
        //Invalid Status Details
        MSG_AP0001: "MSG_AP0001",
        //Seems you have selected Invalid Expected Date.Please choose again
        MSG_AP0002: "MSG_AP0002",
        //Sorry!! We are facing a Technical Glitch
        MSG_AP0003: "MSG_AP0003",
        //Uh Oh!! Currently no dealer is available
        MSG_AP0004: t("No slots available for selected date and time, please select another date and time"),
        //Seems you have selected Invalid Expected Slot.Please choose again
        MSG_AP0005: t("Entered information does not match with the records"),
        //Seems you have entered Invalid Details.Please try again'
        MSG_AP0006: t("MSG_AP0006"),
        //Seems you have entered Invalid Cancellation Details.Please try again
        MSG_AP0007: t("MSG_AP0007"),
        // Installbase Not found
        MSG_AP0008: t("Entered OTP is not valid, please enter valid OTP."),
        // OOPs..Entered OTP seems Invalid.
        MSG_AP0009: t("Dear user mobile number should be 10 digits, entered mobile number is incorrect."),
        //Enter valid Mobile 
        MSG_AP00010: t("Entered mobile number does not match with records, please enter a valid information"),
        //Mobile No Not Registered with VinNumber
        MSG_AP00011: t("Dear user entered VIN number is invalid."),
        //Invalid Installbase Id
        MSG_AP00012: t("MSG_AP00012"),
        //Invalid VinNumber
        MSG_AP00013: t("Vehicle already added for this user"),
        MSG_AP00014: t("Entered characters does not match with records in the system."),
        MSG_AP00015: t("You cannot be able to select the previous date to create a document, it should be greater than the current date"),
        CHCG_001: t("Product is not configured"),
        CHCG_002: t("Product is not configured"),
        CHCG_003: t("Product is not configured"),
        CHCG_004: t("Product is not configured"),
        CHCG_005: t("Product is not configured"),
        IBS_00001: "No matching vehicle found for the entered value.",
        IBS_00002: "No matching vehicle found for the entered value.",
        JCI_00001: "Job card not found. Please check the job card details are correctly entered and try again.",
        JCI_00002: "Invoice not found. Please check the job card details are correctly entered and try again.",
        "Enter Valid MobileNo.": "Enter Valid MobileNo.",
        "Inspection Already Open.": t("Inspection Already Open."),
        //Success Code
        "Logged in successfully": t("Logged in successfully"),
        "OTP sent successfully": t("OTP sent successfully"),
        "Rider saved successfully": t("Rider saved successfully"),
        "Change password successfully": t("Change password successfully"),
        "Created successfully": t("Created successfully"),
        "Updated successfully": t("Updated successfully"),
        "Deleted successfully": t("Deleted successfully"),
        "Only PNG, JPEG, JPG, and HEIC files are allowed.": t("Only PNG, JPEG, JPG, and HEIC files are allowed."),
        "File size exceeds 5 MB. Please choose a smaller file": t("File size exceeds 5 MB. Please choose a smaller file"),
        "Profile photo removed": t("Profile photo removed"),
        "Profile photo not removed": t("Profile photo not removed"),
        "Profile pic is not removed": t("Profile pic is not removed"),
        "Update profile pic failed": t("Update profile pic failed"),
        "Mobile number verified": t("Mobile number verified"),
        "Profile uploaded successfully": t("Profile uploaded successfully"),
        "Last KM Reading is greater": t("Last KM Reading is greater"),
        "Document already Open.": t("Document already Open."),
        "Confirm successfully": "Appointment updated successfully",
        "Saved successfully": "Saved successfully",
        "Mobile no. or  Email already exist.": "Mobile no. or  Email already exist.",
        "Translate to job saved successfully": t("Translate to job saved successfully"),
        "Role is not configured in the system, please configure the role against this user.": t("Role is not configured in the system, please configure the role against this user."),
        "Please Enter odometer reading grater then 0": t("Please Enter odometer reading grater then 0"),
        "It looks like you're offline. Please check your internet connection and try again.": t("It looks like you're offline. Please check your internet connection and try again."),
        "Time out": t("Time out"),
        "Please assign bay": t("Please assign bay")
    };
    return errors.hasOwnProperty(code) ? errors[code] : code ? code : 'Maintenance work is going on, Retry after some time.';
};
export default ErrorsCodes;
